function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.078 18.621L11.04 4.62c.217-.51.823-.754 1.353-.545.256.102.46.298.565.545l5.963 14.001a.987.987 0 01-.565 1.304c-.357.141-.765.08-1.06-.159l-3.964-3.207a2.133 2.133 0 00-2.666 0l-3.964 3.207c-.438.355-1.092.3-1.46-.123a.97.97 0 01-.165-1.022z",
    fill: "#000"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-navigation.svg";